import { SortSettings } from '../components/SortPanel';

/**
 * Gets the default sort settings for CiteRight.
 * Always defaults to "Most relevant" (relevance_score desc).
 *
 * Note: relevance_score is always present on all works - either from Cohere
 * reranking (when available) or from synthetic rank-based scoring.
 */
export const getDefaultSortSettings = (): SortSettings => {
  return { field: 'relevance_score', direction: 'desc' };
};
